import AlertBoxForm from './AlertBoxForm';

export default AlertBoxForm;



// WEBPACK FOOTER //
// ./src/components/AlertBoxForm/index.js